import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { sendServerRequest } from '../../../server/request';
import { openGlobalSnack } from '../../utils/snack';
import { CircularLoading } from '../../utils/loading';

const ENDPOINT = '/server/cltCommand/sumaConfig';

export function SumaConfigPanel() {
  const [comSeguro, setComSeguro] = useState(true);
  const [serverValue, setServerValue] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
  }, []);

  function load() {
    setLoading(true);
    sendServerRequest('GET', `${ENDPOINT}/get`)
      .then((e) => {
        const v = !!e.data?.data?.comSeguro;
        setComSeguro(v);
        setServerValue(v);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        openGlobalSnack('Não foi possível carregar a config do Suma.', 'error');
      });
  }

  function save() {
    setSaving(true);
    sendServerRequest('POST', `${ENDPOINT}/setComSeguro`, { comSeguro })
      .then((e) => {
        const v = !!e.data?.data?.comSeguro;
        setComSeguro(v);
        setServerValue(v);
        setSaving(false);
        openGlobalSnack('Config do Suma atualizada.', 'success');
      })
      .catch(() => {
        setSaving(false);
        openGlobalSnack('Não foi possível salvar a config do Suma.', 'error');
      });
  }

  if (loading) return <CircularLoading />;

  return (
    <div style={{ maxWidth: 520, margin: '0 auto', textAlign: 'center' }}>
      <h3 style={{ marginBottom: 4 }}>Simulação Suma</h3>
      <FormControlLabel
        control={<Switch checked={comSeguro} onChange={(e) => setComSeguro(e.target.checked)} />}
        label="Simular com seguro"
      />
      <p style={{ fontSize: 12, color: '#000000a0', marginTop: 0, marginBottom: 12 }}>
        Se desligado, as simulações do Suma são feitas sem seguro.
      </p>
      <LoadingButton
        loading={saving}
        disabled={comSeguro === serverValue}
        variant="contained"
        onClick={save}
      >
        Salvar
      </LoadingButton>
    </div>
  );
}
